import { API_URLS } from "../constants";
import { postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

//Getting user responses detail by group Id
const getAllFranchiseResponses = (
  createDateFrom,
  createDateTo,
  groupId,
  body,
) => {
  return postRequest(
    `${API_URLS.USER_RESPONSES.GET_GROUP_USER_RESPONSES}/${createDateFrom}/${createDateTo}/${groupId}`,
    body,
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response),
  );
};

export const groupPerformanceService = {
  getAllFranchiseResponses,
};
